import React, { useEffect, useState } from "react";
import { useSiteContext } from "../../contexts/SiteProvider";
import SessionCards from "./SessionCards";

const DashboardTrainer: React.FC = () => {
  const { setTitle } = useSiteContext()
  const [activeTab, setActiveTab] = useState<"today" | "previous" | "completed" | "planned">("today");
  useEffect(() => {
    setTitle("Today Sessions")
  }, []);
  return (
    <SessionCards />
  );
};

export default DashboardTrainer;
